import homepageBanner from '../../images/intro.webp';
import homepageContactSectionBackground from '../../images/hard-adv-5.jpg';
import section1Img1 from '../../images/hard-adv-6.webp';
import section1Img2 from '../../images/hard-adv-7.webp';
import section1Img3 from '../../images/hard-adv-8.webp';

//import tireTracks from '../../images/tire-track.png';

import { Navbar } from '../../components/navbar';
import { Footer } from '../../components/footer';
import AppConfig from '../../utils/appconfig';
import { useEffect } from 'react';
import { SectionTitle } from '../../components/sectionTitle';
import { Banner } from '../../components/banner';
import { LinkButton } from '../../components/linkButton';
import { ContactSection } from '../../components/contactSection';
//import { PartnerSection } from '../../components/partnerSection';
import { scrollBodyToTop } from '../../utils/utils';

const currentPage: string = 'home';

export function HomePage() {
  useEffect(() => {
    document.title = `${AppConfig.baseTabTitle} - Strona główna`;

    scrollBodyToTop();
  }, []);

  return (
    <div className="App theme-light">
      <Navbar currentPage={currentPage} />

      <Banner title={<>THE EASY RIDE <p><span className="text-color--primary">IS OVER</span></p></>}
        backgroundImage={homepageBanner} />

      <section className='content-wrapper home-section-1'>
        <div className="home-section-1__images">
          <img className="home-section-1__images--img-1" src={section1Img1} alt="Motocykl przejeżdżający przez kałużę" />
          <img className="home-section-1__images--img-3" src={section1Img3} alt="Motocykl i pojazd UTV" />
          <img className="home-section-1__images--img-2" src={section1Img2} alt="Uczestnicy imprezy na górze" loading="lazy" />
        </div>

        <div className="home-section-1__text">
          <SectionTitle title={<><span className="text-color--primary">HARD</span> ADV</>} customClassName={'section-title__wrapper--home'} />
          <h3>THE EASY RIDE IS OVER.</h3>
          <p><span className="text-weight--bold">HARD ADV</span> to społeczność ludzi, których łączy jedna pasja – prawdziwa motocyklowa przygoda poza utartymi szlakami.</p>
          <p>Wybieramy szutry, górskie przełęcze, kamieniste szlaki, przeprawy przez rzeki i miejsca, do których większość nigdy nie dociera. Wierzymy, że najlepsze wspomnienia rodzą się tam, gdzie kończy się komfort, a zaczyna prawdziwa przygoda.</p>
          <p>Organizujemy wyprawy i wydarzenia Adventure w Polsce oraz w różnych zakątkach świata. Każdy wyjazd przygotowujemy z dbałością o bezpieczeństwo, organizację i każdy detal, ale to ludzie są tym, co wyróżnia <span className="text-weight--bold">HARD ADV</span>.</p>
          <p>Spotykają się u nas motocykliści z różnych środowisk, których łączy chęć odkrywania świata, pokonywania własnych ograniczeń i jazdy tam, gdzie inni zawracają. To właśnie podczas wspólnych wypraw rodzą się historie i znajomości, które zostają na długie lata.</p>
          <p>Nie jesteśmy biurem podróży. Tworzymy ekspedycje dla motocyklistów Adventure, którzy chcą poznawać świat w autentyczny sposób i przeżywać coś więcej niż zwykłą motocyklową wycieczkę.</p>
          <p><span className="text-weight--bold">HARD ADV</span></p>
          <p>To ludzie. To pasja. To sposób podróżowania.</p>
          <h2>EXPLORE BEYOND LIMITS.</h2>
          <h3>THE EASY RIDE IS OVER.</h3>

          <div>
            <LinkButton buttonText={'ZAPISZ SIĘ TUTAJ'} disabled={false} linkTo={'https://hard-adv.com/rejestracja3'}
              target='_blank' customClassName="home-section-1__button-link-wrapper"
            />

            <LinkButton buttonText={'DOŁĄCZ DO NASZEJ SPOŁECZNOŚCI'} disabled={false} linkTo={'https://hard-adv-society.circle.so/'}
              target='_blank' customClassName="home-section-1__button-link-wrapper home-section-1__button-link-wrapper--red-border"
            />
          </div>
        </div>
      </section>

     {/*<section className='content-wrapper home-section-2'> */}
     {/*   <SectionTitle title={<>NASI <span className="text-color--primary">PARTNERZY</span> 2024</>} customClassName={'section-title__wrapper--home'} />*/}

       {/* <PartnerSection /> */}

        {/* <img src={tireTracks} alt="Ślady opon terenowych" className="home-section-2__tire-tracks" loading="lazy" />*/}
      {/* </section> */}

      <ContactSection title={<>SKONTAKTUJ SIĘ Z NAMI</>} backgroundImage={homepageContactSectionBackground} />

      <Footer currentPage={currentPage} />
    </div>
  );
}
